import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as core from '../../core'

import { FaFunction } from './fa-function'

type FsFunctionBase = core.common.Identified<FsFunction.Id> &
  core.common.Coded &
  core.common.Named
export interface FsFunction extends FsFunctionBase {
  faFunctionCategorization?: FaFunction.Categorization.Ids
}
export namespace FsFunction {
  export const isFsFunction: TypeChecker<FsFunction> = TypeChecker.Factory.lazy(
    () =>
      TypeChecker.Factory.intersection(
        core.common.Identified.getTypeChecker(Id.isId),
        core.common.Named.isNamed,
        core.common.Coded.isCoded,
        TypeChecker.Factory.object<Difference<FsFunction, FsFunctionBase>>({
          faFunctionCategorization: TypeChecker.Factory.optional(
            FaFunction.Categorization.Ids.isIds,
          ),
        }),
      ),
  )

  export type Id = string
  export namespace Id {
    export const isId: TypeChecker<Id> = TypeChecker.isString
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export type Updates = Partial<Pick<FsFunction, 'faFunctionCategorization'>>
  export namespace Updates {
    export const isUpdates: TypeChecker<Updates> = TypeChecker.Factory.lazy(
      () =>
        TypeChecker.Factory.object<Updates>({
          faFunctionCategorization: TypeChecker.Factory.optional(
            FaFunction.Categorization.Ids.isIds,
          ),
        }),
    )

    // TODO: add JSDocs

    export function isValid(updates: Updates): boolean {
      return !updates.faFunctionCategorization
    }

    export function isEmpty(updates: Updates): boolean {
      return Object.values({
        faFunctionCategorization: updates.faFunctionCategorization,
      } satisfies Record<keyof Updates, any>).every(val => val === undefined)
    }

    export function isEqual(update1: Updates, update2: Updates): boolean {
      return stringify(update1) === stringify(update2)
    }

    export function stringify(updates: Updates): string {
      return JSON.stringify({
        faFunctionCategorization:
          updates.faFunctionCategorization !== undefined
            ? JSON.stringify(updates.faFunctionCategorization)
            : undefined,
      } satisfies Record<keyof Updates, string | undefined>)
    }

    // NOTE: Needs to be Map because order matters
    // TODO: why/where does order matter?
    export type Batch = Map<Id, Updates>
    export namespace Batch {
      export const isBatch = TypeChecker.Factory.map(Id.isId, Updates.isUpdates)
    }
  }
}
